// src/analytics-hub/analytics-switch.ts
// The Analytics page is shown only when BOTH are on: the deploy flag `VITE_ANALYTICS` (dev deploy and local dev only, never
// prod: the numbers are the prototype's seeded clinic, fixed at 15 Oct 2026) and this browser's `?x=analytics` switch
// (encounter-flags.ts, off by default; the same pattern as cohort-enrolment-switch.ts).
// With either off: no rail tile, and /analytics says the page is off.
import type { PractitionerNavItem } from '@scripsteam/scrips-signal-ds';
import { env } from '@/config/env';
import { isEncounterFlagOn } from '@/shared/lib/encounter-flags';

export const isAnalyticsOn = (): boolean => env.analyticsEnabled && isEncounterFlagOn('analytics');

export const ANALYTICS_NAV_ITEM: PractitionerNavItem = { id: 'analytics', label: 'Analytics', icon: 'activity' };

/** The rail's tiles plus Analytics when its switch is on. */
export const withAnalytics = (base: PractitionerNavItem[], on: boolean): PractitionerNavItem[] => (on ? [...base, ANALYTICS_NAV_ITEM] : base);
